import { Divider, Grid } from "@mui/material"
import { NumberInput, SelectInput } from "react-admin"

export const TargetEditSection = () => {

    return (
        <>
            <Divider textAlign="left">Targeting</Divider>
            <Grid container spacing={{ xs: 0, md: 2 }}>
                <Grid size={{ xs: 12, md: 6, lg: 3 }}>
                    <SelectInput source="target.role" choices={[
                        { id: "papik", name: "papik" },
                        { id: "baby", name: "baby" }
                    ]} />
                </Grid>
                <Grid size={{ xs: 12, md: 6, lg: 3 }}>
                    <SelectInput source="target.gender" choices={[
                        { id: "male", name: "male" },
                        { id: "female", name: "female" }
                    ]} />

                </Grid>
                <Grid size={{ xs: 12, md: 6, lg: 3 }}>
                    <NumberInput source="target.age.min" />
                </Grid>
                <Grid size={{ xs: 12, md: 6, lg: 3 }}>
                    <NumberInput source="target.age.max" />

                </Grid>
            </Grid>
        </>
    )
}